import { useEffect, useRef } from "react";
import { addToast, Button } from "@heroui/react";
import { storage } from "@/shared/utils/local-storage";

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

export function InstallPWAToast() {
  const toastShown = useRef(false);

  const beforeInstallPrompt = (e: BeforeInstallPromptEvent) => {
    e.preventDefault();
    if (storage.getPwaAlertDismissed() || toastShown.current) return;

    toastShown.current = true;
    addToast({
      endContent: (
        <Button
          color="primary"
          size="sm"
          variant="flat"
          onPress={async () => {
            if (!e) return;

            e.prompt();
            await e.userChoice;
          }}
        >
          Install
        </Button>
      ),
      timeout: Infinity,
      title: "Web app available",
      description: "Install for a better experience.",
      onClose: () => storage.setPwaAlertDismissed(),
    });
  };

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", beforeInstallPrompt as EventListener);

    return () => window.removeEventListener("beforeinstallprompt", beforeInstallPrompt as EventListener);
  }, []);

  return null;
}
